export const CONNECT_NOTIFICATION_DELAY_IN_SECONDS = 24 * 60 * 60;
